export default "__VITE_ASSET__Djn$ukDq__"